import React, { useEffect, useState } from "react";

const VersionInfo = () => {
  const [versions, setVersions] = useState([]);
  const [formData, setFormData] = useState({ version: "", changelog: "" });
  const [editId, setEditId] = useState(null);
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const fetchVersions = () => {
    fetch("https://c1mgcd1she.execute-api.us-east-1.amazonaws.com/prod/api/version_info/")
      .then((res) => res.json())
      .then((data) => setVersions(data));
  };

  useEffect(() => {
    fetchVersions();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const url = editId
      ? `https://c1mgcd1she.execute-api.us-east-1.amazonaws.com/prod/api/version_info/${editId}`
      : "https://c1mgcd1she.execute-api.us-east-1.amazonaws.com/prod/api/version_info/";
    const method = editId ? "PUT" : "POST";

    fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData)
    })
      .then((res) => res.json())
      .then(() => {
        alert(editId ? "Version updated" : "Version added");
        setFormData({ version: "", changelog: "" });
        setEditId(null);
        fetchVersions();
      });
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleEdit = (v) => {
    setFormData({ version: v.version, changelog: v.changelog });
    setEditId(v.id);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure to delete this version?")) {
      fetch(`https://c1mgcd1she.execute-api.us-east-1.amazonaws.com/prod/api/version_info/${id}`, {
        method: "DELETE"
      })
        .then((res) => res.json())
        .then(() => {
          alert("Version deleted");
          fetchVersions();
        });
    }
  };

  return (
    <div className="container mt-4">
      <h3>📌 Version History & Changelog</h3>

      {user.role === "admin" && (
        <form className="card p-3 mb-4" onSubmit={handleSubmit}>
          <div className="mb-3">
            <label>Version</label>
            <input
              className="form-control"
              name="version"
              value={formData.version}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label>Changelog</label>
            <textarea
              className="form-control"
              name="changelog"
              value={formData.changelog}
              onChange={handleChange}
              required
            />
          </div>
          <button className="btn btn-primary" type="submit">
            {editId ? "Update" : "Add"} Version
          </button>
        </form>
      )}

      {versions.map((v) => (
        <div className="card my-3" key={v.id}>
          <div className="card-body">
            <h5 className="card-title">Version {v.version}</h5>
            <p className="card-text">{v.changelog}</p>
            <p className="card-text">
              <small className="text-muted">
                Released: {new Date(v.created_at).toLocaleString()}
              </small>
            </p>
            {user.role === "admin" && (
              <>
                <button
                  className="btn btn-sm btn-warning me-2"
                  onClick={() => handleEdit(v)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(v.id)}
                >
                  Delete
                </button>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VersionInfo;
